<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["1393"]') }}
      </h1>
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit="handleSubmit"
    >
      <a-form-item
        :label="curPwd"
      >
        <a-input
          v-decorator="decorators.password"
          type="password"
          :placeholder="curPwdPlaceTxt"
        />
      </a-form-item>
      <a-form-item
        :label="newPwdTit"
      >
        <a-popover
          title=""
          trigger="focus"
          overlay-class-name="input-tip-tip-box"
        >
          <template slot="content">
            <p>{{ $t('message["633"]') }}</p>
          </template>
          <a-input
            v-decorator="decorators.newpwd"
            type="password"
            :placeholder="newPwdPlaceholder"
          />
        </a-popover>
      </a-form-item>
      <a-form-item
        :label="rePwdTit"
      >
        <a-input
          v-decorator="[
            'renewpassword',
            {rules: [
              {required: true, message: pwdNewPlaceholder},
              {validator: checkPassword}
            ]}
          ]"
          type="password"
          :placeholder="pwdNewPlaceholder"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { clearAuth, clearPid } from '@/lib/storage'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators']),
    curPwd () {
      return this.$t('message["165"]')
    },
    curPwdPlaceTxt () {
      return this.$t('message["760"]')
    },
    newPwdPlaceholder () {
      return this.$t('message["816"]')
    },
    pwdNewPlaceholder () {
      return this.$t('message["891"]')
    },
    newPwdTit () {
      return this.$t('message["1342"]')
    },
    rePwdTit () {
      return this.$t('message["1616"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('account/modify', ['modifyPassword']),
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // console.log(values)
          const chain = await this.modifyPassword()
          chain.params(values)
            .onSuccess(res => {
              let Authorization = ''
              // setAuth(Authorization)
              clearAuth()
              clearPid()
              this.$store.commit('setAuth', Authorization)
              // this.$message.success('修改成功')
              this.$router.replace({ name: 'AccountLogin' })
            })
            .onNetSuccess((res) => {
              if (res.data.error) {
                this.$message.warning(res.data.message || res.data.payload[0].message)
              }
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    },
    // 校验二次输入的密码是否一致
    checkPassword (rule, value, callback) {
      const { getFieldValue } = this.form
      if (value !== getFieldValue('newpassword')) {
        callback(new Error(this.$t('message["607"]')))
      } else {
        callback()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
</style>
